import classNames from 'classnames';
import { ServicesSubservicesSliderItem } from '@sapientpro/sapientpro-data-models';
import { useAtomValue } from 'jotai';
import styles from './ServicesSlider.module.scss';
import { theme } from '../../store/theme';

const ServiceSliderCard = ({ item }: { item: ServicesSubservicesSliderItem }) => {
  const currentTheme = useAtomValue(theme);
  const itemLink = item.service?.slug || item.subService?.slug;
  const link = `/${itemLink}`;

  const Wrapper = itemLink ? 'a' : 'div';

  return (
    <Wrapper
      {...(itemLink ? { href: link } : {})}
      className={classNames(styles.serviceSliderCard, {
        [styles.link]: !!itemLink,
      })}
    >
      <div className={styles.content}>
        <h3 className={styles.title}>{item.title}</h3>
        <p className={classNames(styles.description, 'bodySmall')}>{item.text}</p>
      </div>

      <img
        className={styles.shadow}
        src={`media/service-slider-card-shadow-${currentTheme}.svg`}
        alt='decoration'
      />

      <img
        className={styles.decoration}
        src={`media/service-slider-decoration-${currentTheme}.svg`}
        alt='decoration'
      />
    </Wrapper>
  );
};

export default ServiceSliderCard;
